exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mat-toolbar mat-form-field.contract-state {\n  font-size: 60%;\n  width: 100px;\n  margin-right: 20px; }\n\nmat-slide-toggle {\n  margin-top: 12px; }\n\nmat-expansion-panel-header mat-slide-toggle {\n  margin-top: 0;\n  margin-left: 8px; }\n\nmat-expansion-panel-header mat-icon {\n  margin-right: 8px; }\n\ndiv.mat-input-suffix {\n  margin-left: 6px !important; }\n\nmat-panel-title mat-error, mat-panel-title mat-hint {\n  margin-left: 20px; }\n\n.summary .col-6 {\n  -ms-flex-item-align: center;\n      -ms-grid-row-align: center;\n      align-self: center; }\n  .summary .col-6 input {\n    padding-right: 6px; }\n\n.terms .col-4 input {\n  padding-right: 6px; }\n\nimg.qr {\n  max-width: 100%; }\n\n.terms div.row {\n  margin-top: 8px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/ContractsModule/ContractEditComponent/contract-edit.component.scss
// module id = ../../../../../src/ContractsModule/ContractEditComponent/contract-edit.component.scss
// module chunks = main